<template>
  <div>
    <a @click="gotoLink(cardData.url)" class="card-link">
      <v-hover v-slot="{ hover }" open-delay="200">
        <v-card
          :elevation="hover ? 12 : 2"
          :class="{ 'on-hover': hover }"
          class="mx-auto dashboard-card"
        >
          <!-- Purple top border accent -->
          <!-- <div class="card-top-border"></div> -->

          <v-card-text class="card-body">
            <!-- Illustration image -->
            <div class="card-illustration">
              <img
                v-if="cardData.image"
                :src="cardData.image"
                :alt="cardData.toppic"
                class="card-img"
              />
              <v-icon v-else size="40" color="#7c4dff">{{
                cardData.icon
              }}</v-icon>
            </div>

            <!-- Title -->
            <div class="card-title">{{ cardData.toppic }}</div>

            <!-- Description -->
            <p
              :class="{
                'f-10': cardData.toppic === 'Teaching record',
                'f-13': cardData.toppic !== 'Teaching record',
              }"
              class="card-description"
            >
              {{ cardData.detail }}
            </p>
          </v-card-text>

          <!-- Click Here button -->
          <!--  
            <v-card-actions class="card-actions-wrapper">
            <div class="click-here-btn">
              Click Here
            </div>
          </v-card-actions>
          -->
        </v-card>
      </v-hover>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    gotoLink(UrlLink) {
      if (
        UrlLink === "https://ks.muic.io/ScoreByInstructor" ||
        UrlLink === "https://newmy.muic.io/teaching" ||
        UrlLink === "https://newmy.muic.io/service" ||
        UrlLink === "https://ks.muic.io/QuestionnaireByInstructor"
      ) {
        window.open(UrlLink, "_blank");
      } else {
        this.$router.push(UrlLink).catch((err) => {});
      }
    },
  },
};
</script>

<style scoped>
.card-link {
  text-decoration: none;
}

.dashboard-card {
  min-height: 270px;
  border-radius: 8px !important;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #ffffff !important;
  transition: all 0.3s ease;
  cursor: pointer;
}

.dashboard-card:hover {
  transform: translateY(-3px);
}

.card-top-border {
  height: 4px;
  width: 100%;
  background: linear-gradient(90deg, #0d47a1, #0d47a1, #0d47a1);
  flex-shrink: 0;
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 14px 16px 6px !important;
  flex: 1;
}

.card-illustration {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 6px;
  line-height: 1.3;
}

.card-description {
  color: #000000 !important;
  line-height: 1.4;
  margin-bottom: 0;
}

.f-13 {
  font-size: 12px;
}

.f-10 {
  font-size: 11px;
}

.card-actions-wrapper {
  display: flex;
  justify-content: center;
  padding: 8px 16px 16px !important;
  flex-shrink: 0;
}

.click-here-btn {
  border: 2px solid #ffffff;
  color: #ffffff;
  padding: 5px 22px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none;
}

.click-here-btn:hover {
  background: #ffffff;
  color: #ffffff;
  box-shadow: 0 3px 10px rgba(124, 77, 255, 0.4);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .dashboard-card {
    min-height: 240px;
  }
  .card-illustration {
    width: 65px;
    height: 65px;
  }
  .card-title {
    font-size: 14px;
  }
  .f-13 {
    font-size: 11px;
  }
  .f-10 {
    font-size: 10px;
  }
  .click-here-btn {
    padding: 4px 18px;
    font-size: 12px;
  }
}

@media (max-width: 600px) {
  .dashboard-card {
    min-height: 220px;
  }
  .card-illustration {
    width: 55px;
    height: 55px;
  }
  .card-body {
    padding: 10px 12px 4px !important;
  }
  .card-title {
    font-size: 13px;
  }
  .f-13 {
    font-size: 10px;
  }
  .click-here-btn {
    padding: 3px 14px;
    font-size: 11px;
  }
}
</style>

<style lang="sass" scoped>
.v-card.on-hover.theme--dark
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>
